module.exports = __webpack_public_path__ + "img/钩藤.2f42cd9d.jpg";